export default "__VITE_ASSET__4553ef1e__"